<template>
    <nav
        class="flex items-stretch justify-between shadow-none"
        :class="navClass"
        style="background-color: var(--ui-surface-raised); box-shadow: inset 0 1px 0 var(--border-ultralight);"
    >
        <div class="hidden sm:flex items-center px-6 py-4 text-sm leading-5 text-gray-700">
            <span>{{ start }} {{ $t('to') }} {{ end }}</span>
            <span class="ml-3 inline-flex items-center justify-center min-w-[1.5rem] h-6 px-2 rounded border border-gray-400 bg-transparent text-xs font-medium text-gray-700">
                {{ total }}
            </span>
        </div>
        <div class="ml-auto flex items-center border-l border-ultralight px-6 py-4">
            <button
                :class="currentPage <= 1 ? 'opacity-50 cursor-not-allowed' : ''"
                :disabled="currentPage <= 1"
                :aria-label="$t('Back')"
                class="btn-stage-icon-plain"
                :title="$t('Back')"
                type="button"
                @click="$emit('prev')"
            >
                <svg-vue class="h-4 w-4" icon="font-awesome.regular.chevron-left"></svg-vue>
            </button>
            <button
                :class="currentPage >= totalPages ? 'opacity-50 cursor-not-allowed' : ''"
                :disabled="currentPage >= totalPages"
                :aria-label="$t('Next')"
                class="btn-stage-icon-plain ml-6"
                :title="$t('Next')"
                type="button"
                @click="$emit('next')"
            >
                <svg-vue class="h-4 w-4" icon="font-awesome.regular.chevron-right"></svg-vue>
            </button>
        </div>
    </nav>
</template>

<script>
export default {
    name: 'list-footer-pagination',
    props: {
        start: {
            type: Number,
            required: true,
        },
        end: {
            type: Number,
            required: true,
        },
        total: {
            type: Number,
            required: true,
        },
        currentPage: {
            type: Number,
            required: true,
        },
        totalPages: {
            type: Number,
            required: true,
        },
        navClass: {
            type: String,
            default: '',
        },
    },
    emits: ['prev', 'next'],
};
</script>
